export const reduceSetFreshBoardKey = (
  state,
  { payload: { boardIDs, fresh, key } },
) => {
  if (!Array.isArray(boardIDs) || !boardIDs.length || !key) return state;

  const newBoards = {
    ...state.boards,
  };

  for (let i = 0, l = boardIDs.length; i < l; i += 1) {
    const boardId = boardIDs[i];
    newBoards[boardId] = {
      ...(state?.boards?.[boardId] || {}),
      [key]: fresh,
    };
  }

  return {
    ...state,
    boards: newBoards,
  };
};
